import { Component, Input, OnInit } from '@angular/core';
import { FlowItemModel } from '../../models/FlowItemModel';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';


@Component({
    selector: 'app-note-card-player',
    imports: [CommonModule, MatDividerModule, MatIconModule, MatCardModule],
    templateUrl: './note-card-player.component.html',
    styleUrls: ['./note-card-player.component.css']
})
export class NoteCardPlayerComponent implements OnInit {
  @Input() Note: FlowItemModel;
  constructor() { }

  ngOnInit() {
  }

}
